// extracted by mini-css-extract-plugin
module.exports = {"btngray":"settingStyle_btngray__1uUoD"};